import { createStyles } from 'antd-style'

export const useStyle = createStyles({
  mediaCard: {
    minHeight: 375
  }
})
